import { categoriesAll } from "@/mocks/homeData";

interface Props {
  onSelect: (key: string) => void;
}

export default function Categories({ onSelect }: Props) {
  const items = categoriesAll.filter((c) => c.key !== "all");
  return (
    <section id="columns" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
            <i className="ri-grid-fill" aria-hidden="true"></i>分类直达
          </span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            你的专属瓜田，分栏找到
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700">
            按你关心的领域切分热议内容，点进任意栏目即可直达该方向的事件盘点。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => onSelect(c.key)}
              className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 text-left transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600">
                <i className={`${c.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center justify-between text-base font-bold text-foreground-950">
                  {c.name}
                  <i className="ri-arrow-right-up-line text-foreground-300 transition-all group-hover:text-primary-500" aria-hidden="true"></i>
                </span>
                <span className="mt-1.5 block text-xs leading-relaxed text-foreground-600">{c.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}